<!--
 * @Author: your name
 * @Date: 2021-11-05 11:51:26
 * @LastEditTime: 2023-06-15 16:41:41
 * @LastEditors: lizhenhao
 * @Description: 办卡 用户信息
 * @FilePath: \newProject\h5\src\pages\userInformation\index.vue
-->

<template>
  <div class="app-container">
    <div class="logo">
      <img class="image" src="../../assets/logo.png" alt="" />
    </div>

    <div class="userForm">
      <!-- 用户信息 -->
      <van-form @submit="onSubmit" label-width="20vw" label-align="right" validate-trigger="onSubmit">
        <van-field v-model="userForm.name" name="用户名" label="真实姓名" placeholder="请填写申请人姓名" @blur="onBlur"
          :rules="[{ required: true, message: '' }]" />
        <van-field v-model="userForm.phone" maxlength="11" type="tel" name="手机号" label=" 手 机 号" placeholder="请填写申请人手机号"
          capture="camera" :rules="[{ required: true, message: '' }]" />
        <van-field v-model="userForm.idCard" maxlength="18" name="身份证" label=" 身 份 证" placeholder="请填写申请人身份证号码"
          :rules="[{ required: true, message: '' }]">
        </van-field>
        <van-field v-model="userForm.smsCode" maxlength="6" name="验证码" label=" 验 证 码" placeholder="请填写验证码"
          :rules="[{ required: true, message: '' }]">
          <template #button>
            <van-button round v-if="isFalg" size="small" type="info" native-type="button" @click="getCode">
              获取验证码
            </van-button>
            <van-button round v-else disabled size="small" type="info">
              {{ time }}秒后获取
            </van-button>
          </template>
        </van-field>
        <div class="agreement">
          <van-checkbox v-model="agreement" class="ty" icon-size="18px">
            我同意
          </van-checkbox>
          <span class="tick"><span @click="khAuthorizationAgreement">《用户授权协议》</span>与<span
              @click="khRegistrationAgreement">《易伙伴注册服务协议》</span></span>
        </div>
        <div class="goBtn">
          <van-button round block type="info" native-type="submit" :disabled="btnShow">去 申 请</van-button>
        </div>
      </van-form>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="show" :title="title" width="380">
      <div class="diaAgreement" v-html="html"></div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Submit, getCode, link, khAuthorizationAgreement, khRegistrationAgreement } from "@/api/index";
export default {
  name: "UserInformation",
  data() {
    return {
      userForm: {
        name: "", //  性名
        phone: "", //  手机号
        smsCode: "", //  验证码
        idCard: "", //  身份证号码
        referKey: "", //  邀请码
        creditId: "", //  资源ID
        channelId: "", //  资源渠道  0 == 卡盒   1 == 网申
      },
      isFalg: true, //  获取验证码按钮是否禁用
      time: null, //  倒计时
      zIndex: -1,
      agreement: false, //  协议
      goUrl: "", //  去申请的 链接地址
      btnShow: false, // 控制按钮的开饭
      code: "", //  资源 编 码
      referKey: "", //  合伙人邀请码
      id: 0, //  资源 id
      jumpType: "", // 跳转方式    0 == 直接跳转      1 == 二维码页面

      show: false,  // 弹窗的关闭隐藏
      title: "",  //  对话框的标题
      html: ""
    };
  },
  created() {
    console.log("VVVVVVV", this.$route.query);

    // TODO 获取到二维码中的信息
    this.userForm.referKey = this.$route.query.referKey; //  合伙人邀请码
    this.userForm.creditId = this.$route.query.creditId; //  资源ID
    this.userForm.channelId = this.$route.query.channelId; //  资源渠道     0 == 卡盒   1 == 网申
    this.jumpType = this.$route.query.t; //  跳转方式

    console.log(this.$route.query);
    this.btnShow = false;
    this.$dialog
      .alert({
        title: `重要提示 ！！！`,
        message: `<p style='color: #ef7d1a; fontSize: 600;'>请确保以上均为申请办卡人真实信息，后续申请资料需填写一致</p>`,
        // showCancelButton: true,
      })
      .then(() => {
      })
      .catch(() => {
      });
  },
  methods: {
    // 姓名校验
    onBlur() {
      let _name = new RegExp(
        "^[\u4E00-\u9FA5]{1,10}[·]{0,1}[\u4E00-\u9FA5]{1,20}$"
      );
      if (!_name.test(this.userForm.name + "")) {
        this.$notify({
          type: "warning",
          message: "请输入合法姓名",
        });
        return;
      }
    },

    // 获取信用卡 办卡连接
    goLink() {
      let code = this.code;
      link({ code: code }).then((res) => {
        this.userForm.bankUrl = res.msg;
      });
    },

    // 去申请
    async onSubmit(val) {
      console.log(val);
      this.btnShow = true;
      // 姓名校验规则
      let _name = new RegExp(
        "^[\u4E00-\u9FA5]{1,10}[·]{0,1}[\u4E00-\u9FA5]{1,20}$"
      );
      if (!_name.test(this.userForm.name + "")) {
        this.$notify({
          type: "warning",
          message: "请输入合法姓名",
        });
        this.btnShow = false;
        return;
      }

      // 身份证校验规则
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      // 校验身份证：
      if (
        _IDRe18.test(this.userForm.idCard) ||
        _IDre15.test(this.userForm.idCard)
      ) {
        if (!this.agreement) {
          Toast("请阅读并勾选协议");
          this.$notify({
            type: "warning",
            message: "请阅读并勾选协议",
          });
          this.btnShow = false;
          return;
        }

        // 给出提示 填写表格信息保持一直
        this.$dialog
          .alert({
            title: `重要提示 ！！！`,
            message: `<p style='color: #ef7d1a; fontSize: 600;'>请确保以上均为申请办卡人真实信息，后续申请资料需填写一致</p>`,
            showCancelButton: true,
          })
          .then((res) => {
            console.log(res);

            //  发起请求 获取跳转连接  请求参数看接口文档
            console.log("this.userForm", this.userForm);
            Submit(this.userForm).then((res) => {
              if (res.code != 200) {
                this.$notify({
                  type: "danger",
                  message: res.msg,
                });
                this.btnShow = false;
                return;
              }

              console.log(res);
              //  res  判断this.jumpType是跳转方式  然后跳转到办卡连接页面/二维码页面
              if (this.jumpType == 0) {
                // 直接跳转
                window.location.href = res.msg

              }
              if (this.jumpType == 1) {
                // 二维码跳转
                //    设置缓存
                window.localStorage.setItem("jumpLink", res.msg);
                // 把获取到的连接放到缓存中 到qr页面去读缓存 生成二维码
                this.$router.push("/qr");
              }

              this.$notify({
                type: "success",
                message: "信息核验成功",
              });
            });

          })
          .catch(() => {
            this.btnShow = false;
          });
      } else {
        this.$notify({
          type: "warning",
          message: "请正确的输入身份证号码",
        });
        this.btnShow = false;
      }
    },

    // 扫描身份证
    getCardId() { },

    // 获取验证码
    getCode() {
      this.time = 60;
      let timer = null;
      // 验证手机号
      let str = /^[1]([3-9])[0-9]{9}$/;
      if (!str.test(this.userForm.phone)) {
        this.$notify({
          type: "danger",
          message: "请输入正确的手机号",
        });
        return;
      }

      this.isFalg = false;
      timer = setInterval(() => {
        this.time--;
        if (this.time <= 1) {
          clearTimeout(timer);
          this.isFalg = true;
          return;
        }
      }, 1000);

      getCode(this.userForm.phone)
        .then((res) => {
          if (res.code != 200) {
            this.$notify({
              type: "danger",
              message: res.msg,
            });
            return;
          }
          this.$notify({
            type: "primary",
            message: "验证码已发送",
          });
        })
        .catch((err) => {
          console.log("err, err", err);
          this.time = 60;
          this.isFalg = true;
          clearTimeout(timer);
          // vconsole.log()
          this.$notify({
            type: "danger",
            message: err.msg,
          });
        });
    },
    // 授权协议
    khAuthorizationAgreement() {
      this.title = "用户授权协议"
      this.show = true
      khAuthorizationAgreement().then(res => {
        this.html = res.data.content;
      })
      // this.$router.push("/khAuthorizationAgreement");
    },
    // 注册服务协议
    khRegistrationAgreement() {
      this.title = "易伙伴注册服务协议"
      this.show = true
      khRegistrationAgreement().then(res => {
        this.html = res.data.content
      })
      // this.$router.push("/khRegistrationAgreement");
    },
  },
};
</script>

<style scoped>
.logo {
  width: 60%;
  margin: 10vh auto;
}

.logo .image {
  width: 100%;
  height: 70px;
}

.app-container {
  height: 100vh;
  overflow: hidden;
}

.agreement {
  width: 100%;
  padding-left: 2vw;
  margin: 10px;
  font-size: 13px;
  display: flex;
}

.tick span {
  color: #fa4f5f;
}

.goBtn {
  margin: 0 auto;
  width: 90vw;
  margin-top: 50px;
}

/* .van-dialog__header p{
  color: red;
} */

.diaAgreement {
  height: 500px;
  padding: 10px;
  overflow: auto;
  text-indent: 1.5em;
}
</style>
